import { render, staticRenderFns } from "./ColorLinesRegistryEditForm.vue?vue&type=template&id=4833ce24"
import script from "./ColorLinesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./ColorLinesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports